import { ComponentProps, JSXElementConstructor } from 'react';

import { registerModals } from '@betty/navigation';
import TermsAndConditionsPage from '../pages/MiscPages/TermsPage/TermsPage';
import PrivacyPolicyPage from '../pages/MiscPages/PrivacyPolicy/PrivacyPolicy';
import ResponsibleGamingPage from '../pages/MiscPages/ResponsibleGaming/ResponsibleGaming';

import '@betty/auth/modals';
import '@betty/account/modals';
import '@betty/details-attestation/modals';
import '@betty/daily-scratcher/modals';
import '@betty/registration/modals';

const modals = {
  TermsScreenModal: TermsAndConditionsPage,
  PrivacyModal: PrivacyPolicyPage,
  ResponsibleGamingModal: ResponsibleGamingPage,
};

registerModals('web', modals);

declare global {
  interface RegisteredModals {
    web: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}
